<template>
  <div class="page-box">
    <!-- 头部组件 -->
    <ProductHeader :currentTab="1.1" stepTitle="票型及价格"></ProductHeader>
    <div class="page-main">
      <!-- 发布助手 -->
      <PublishHelper></PublishHelper>
      <div class="main-content">
        <a-card :bordered="false" :headStyle="{borderBottom:'0px'}" :bodyStyle="{paddingTop:'0px'}">
          <a-row slot="title">
            <a-col :span="8">
              <span class="card-title">票型信息</span>
            </a-col>
          </a-row>
          <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules"
                        :label-col="currentFormLayout.labelCol" :wrapper-col="currentFormLayout.wrapperCol"
          >
            <a-form-model-item label="套餐名称" prop="optionName">
              <a-input v-model="ruleForm.optionName" :maxLength="50" style="max-width:700px;" placeholder="请输入">
                <span slot="addonAfter">{{ ruleForm.optionName.length }}/50</span>
              </a-input>
            </a-form-model-item>
            <a-form-model-item label="联系人信息">
              <LinkmanItem ref="linkMan" :contractMessage="ruleForm.optionContractInfo"
                           :requiredList="ruleForm.optionMustContractInfo"
                           @change="changeLinkMan"
              ></LinkmanItem>
            </a-form-model-item>
            <a-form-model-item label="游客信息">
              <TouristItem
                :catalogId="1"
                :isPlayName="ruleForm.optionIsPlayName"
                :optionTouristSelct="ruleForm.optionTouristinformation"
                @change="getIsPlayName" @selectChange="getSelectTourist"
              ></TouristItem>
            </a-form-model-item>
            <a-form-model-item label="提前购买时间" required>
              <a-radio-group v-model="ruleForm.optionBuyInAdvanceSet">
                <a-radio :style="radioStyle" :value="0">用户可随时购买使用</a-radio>
                <a-radio :style="radioStyle" :value="1">
                  <span>用户需提前 &nbsp;</span>
                  <a-form-model-item class="inline mr15"
                                     :prop="ruleForm.optionBuyInAdvanceSet==1?'optionAdvanceHours1':'required'">
                    <a-input v-model.number="ruleForm.optionAdvanceHours1" style="max-width:150px;" placeholder="请输入"
                             suffix="小时"/>
                  </a-form-model-item>
                  <a-form-model-item class="inline mr15"
                                     :prop="ruleForm.optionBuyInAdvanceSet==1?'optionAdvanceMinute1':'required'">
                    <a-input v-model.number="ruleForm.optionAdvanceMinute1" style="max-width:150px;"
                             placeholder="请输入" suffix="分钟"/>
                  </a-form-model-item>
                  <span>预订，方可使用</span>
                </a-radio>
                <a-radio :style="radioStyle" :value="2" style="margin-top:15px;">
                  <span>用户需在游玩 &nbsp;</span>
                  <a-form-model-item class="inline mr15"
                                     :prop="ruleForm.optionBuyInAdvanceSet==2?'optionAdvanceDay':'required'">
                    <a-input v-model.number="ruleForm.optionAdvanceDay" style="max-width:150px;" placeholder="请输入"
                             suffix="天"/>
                  </a-form-model-item>
                  <a-form-model-item class="inline mr15"
                                     :prop="ruleForm.optionBuyInAdvanceSet==2?'optionAdvanceHours':'required'">
                    <a-input v-model.number="ruleForm.optionAdvanceHours" style="max-width:150px;" placeholder="请输入"
                             suffix="点"/>
                  </a-form-model-item>
                  <a-form-model-item class="inline mr15"
                                     :prop="ruleForm.optionBuyInAdvanceSet==2?'optionAdvanceMinute':'required'">
                    <a-input v-model.number="ruleForm.optionAdvanceMinute" style="max-width:150px;" placeholder="请输入"
                             suffix="分"/>
                  </a-form-model-item>
                  <span>前预订，方可使用</span>
                </a-radio>
              </a-radio-group>
            </a-form-model-item>
            <a-form-model-item label="预订数量限制" class="mb0">
              <a-form-model-item class="inline mr15" prop="optionMinTotal">
                <a-input v-model.number="ruleForm.optionMinTotal" placeholder="请输入" addon-before="每笔订单最少购买"
                         suffix="份"/>
              </a-form-model-item>
              <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <a-form-model-item class="inline">
                <a-input v-model.number="ruleForm.optionMaxTotal" placeholder="请输入" addon-before="最多购买"
                         suffix="份"/>
              </a-form-model-item>
            </a-form-model-item>
            <a-form-model-item label="订单取消时间" prop="optionOrderPlayDate">
              <a-input v-model.number="ruleForm.optionOrderPlayDate" style="max-width:700px;" placeholder="请输入"
                       suffix="分钟后不支付自动取消 建议30分钟"/>
            </a-form-model-item>
            <a-form-model-item label="退款规则" required>
              <a-radio-group v-model="ruleForm.optionRefundTermsState">
                <a-radio :style="radioStyle" :value="1">
                  随时退(未消费订单，无论是否过期，订单可多次退款，随时可退，无退款手续费。)
                </a-radio>
                <a-radio :style="radioStyle1" :value="2">
                  <span>有条件退款(未消费订单，无论是否过期，订单可多次退款，随时可退，无退款手续费。)</span>
                  <a-row>
                    <span class="lh40">时间限制：&nbsp;</span>
                    <a-form-model-item class="inline mr15" style="max-width:125px;">
                      <a-select v-model="ruleForm.optionRefundTerms" placeholder="请选择">
                        <a-select-option :value="2">有效期结算后</a-select-option>
                        <a-select-option :value="0">无限制</a-select-option>
                        <a-select-option :value="1">有效期结算前</a-select-option>
                      </a-select>
                    </a-form-model-item>
                    <a-form-model-item class="inline mr15" prop="optionRefundDay">
                      <a-input :disabled="ruleForm.optionRefundTerms<1" v-model.number="ruleForm.optionRefundDay"
                               placeholder="请输入" suffix="天"/>
                    </a-form-model-item>
                    <a-form-model-item class="inline mr15" prop="optionRefundHours">
                      <a-input :disabled="ruleForm.optionRefundTerms<1" v-model.number="ruleForm.optionRefundHours"
                               placeholder="请输入" suffix="点"/>
                    </a-form-model-item>
                    <a-form-model-item class="inline mr15" prop="optionRefundMinute">
                      <a-input :disabled="ruleForm.optionRefundTerms<1" v-model.number="ruleForm.optionRefundMinute"
                               placeholder="请输入" suffix="分"/>
                    </a-form-model-item>
                  </a-row>
                </a-radio>
                <a-radio :style="radioStyle" :value="0">
                  不可退（一经购买，不可退款。不可退可能造成商品曝光或销量的不良影响，请慎重勾选该项）
                </a-radio>
              </a-radio-group>
            </a-form-model-item>
            <a-form-model-item label="退款说明">
              <a-textarea v-model="ruleForm.optionCancelRules" :maxLength="500" placeholder="请输入"
                          :auto-size="{minRows:4,maxRows: 8}"/>
            </a-form-model-item>
            <a-form-model-item label="入园方式">
              <a-textarea v-model="ruleForm.optionUseway" :maxLength="500" placeholder="请输入"
                          :auto-size="{minRows:4,maxRows:8}"/>
            </a-form-model-item>
            <a-form-model-item label="费用说明">
              <a-textarea v-model="ruleForm.optionFeeContain" :maxLength="500" placeholder="请输入"
                          :auto-size="{minRows:4,maxRows: 8}"/>
            </a-form-model-item>
            <a-form-model-item label="其他">
              <a-textarea v-model="ruleForm.optionDes" :maxLength="500" placeholder="请输入"
                          :auto-size="{minRows:4,maxRows:8}"/>
            </a-form-model-item>
            <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
              <a-button type="primary" :disabled="proSource!=0" @click="onSubmit" :loading="submitLoading">提交
              </a-button>
              <!-- <a-button  @click="backEvent" style="margin-left: 10px">保存草稿</a-button> -->
            </a-form-model-item>
          </a-form-model>
        </a-card>

      </div>
    </div>
  </div>
</template>

<script>
import ProductHeader from '../components/ProductHeader'
import PublishHelper from '../components/PublishHelper'
import ruleFormMixins from '@/utils/mixins/ruleFormMixins'
import TouristItem from '../components/TouristItem'
import LinkmanItem from '../components/LinkmanItem'
import moment from 'moment'

export default {
  name: 'TicketsOptionInfo',
  components: {
    ProductHeader,
    PublishHelper,
    TouristItem,
    LinkmanItem
  },
  mixins: [ruleFormMixins],
  data() {
    return {
      moment,
      ticketPackageList: [],//景点票型集合
      proSource: this.$route.query.proSource, //判断自有产品还是非自有产品
      proId: this.$route.query.proId, //产品ID
      catalogId: this.$route.query.catalogId,
      optionId: this.$route.query.optionId,
      ruleForm: {
        optionBuyInAdvanceSet: 0, //提前购买时间
        optionAdvanceDay: '', //提前预订天
        optionAdvanceHours: '', //提前预订小时
        optionAdvanceMinute: '', //提前预订分
        optionAdvanceHours1: '', //提前预订小时
        optionAdvanceMinute1: '', //提前预订分
        optionCancelRules: '', //退改说明
        optionFeeContain: '', //费用说明
        optionName: '', //票型名称
        optionRefundDay: '', //退改规则，提前天
        optionRefundHours: '', //退改规则，提前时
        optionRefundMinute: '', //退改规则，提前分
        optionRefundTerms: 0, //退款条件
        optionRefundTermsState: 0, //退款类型,0不可退，1随时退，2.有条件退
        proId: this.$route.query.proId,
        optionId: this.$route.query.optionId,
        optionContractInfo: '', //联系人信息
        optionDes: '', //门票:其他
        optionIsPlayName: 0, //游客信息: 0,不需要游客信息,1需要1个游客信息, 2,需要所有游客信息
        optionMaxTotal: 10,
        optionMinTotal: 1,
        optionOrderPlayDate: 30, //超时付款时间（超过时间后自动取消订单）
        optionTouristinformation: [], //游客信息
        optionUseway: '', //入园方式
        optionUpdateTime: '' //传空
      },
      bedTypeList: [],
      hotelBindBeds: [],
      submitLoading: false,
      submitFormData: '',
      radioStyle: {
        display: 'block',
        height: '40px',
        lineHeight: '40px'
      },
      radioStyle1: {
        display: 'block',
        height: '80px'
      },
      rules: {
        optionName: [
          { required: true, message: '请输入景点票型名称', trigger: 'blur' }
        ],
        optionAdvanceDay: [
          { required: true, message: '请输入天数', trigger: 'blur' },
          { type: 'number', min: 0, max: 30, message: '请输入0-30之间的数字', trigger: 'blur' },
          { pattern: /^[0-9]\d{0,2}$/, message: '请输入正确的天数', trigger: 'blur' }
        ],
        optionAdvanceHours1: [
          { required: true, message: '请输入小时', trigger: 'blur' },
          { pattern: /^([0-9]|(1[0-9])|(2[0-3]))$/, message: '请输入正确的时间0-23', trigger: 'blur' }
        ],
        optionAdvanceMinute1: [
          { required: true, message: '请输入分钟', trigger: 'blur' },
          { type: 'number', min: 0, max: 59, message: '请输入0-59之间的数字', trigger: 'blur' },
          { pattern: /^[0-9]\d{0,2}$/, message: '请输入正确的分钟', trigger: 'blur' }
        ],
        optionAdvanceHours: [
          { required: true, message: '请输入小时', trigger: 'blur' },
          { pattern: /^([0-9]|(1[0-9])|(2[0-3]))$/, message: '请输入正确的时间0-23', trigger: 'blur' }
        ],
        optionAdvanceMinute: [
          { required: true, message: '请输入分钟', trigger: 'blur' },
          { type: 'number', min: 0, max: 59, message: '请输入0-59之间的数字', trigger: 'blur' },
          { pattern: /^[0-9]\d{0,2}$/, message: '请输入正确的分钟', trigger: 'blur' }
        ],
        optionOrderPlayDate: [
          { required: true, message: '请输入订单取消时间', trigger: 'blur' },
          { type: 'number', min: 1, max: 60, message: '请输入1-60之间的数字', trigger: 'blur' }
        ],
        optionRefundTermsState: [
          { required: true, message: '请选择退款规则', trigger: 'change' }
        ],
        optionIsPlayName: [
          { required: true, message: '请选择游客信息', trigger: 'change' }
        ],
        optionMinTotal: [
          { required: true, message: '请输入预订数量限制', trigger: 'blur' }
        ],
        optionMaxTotal: [
          { pattern: /^[1-9]\d{0,5}$/, message: '请输入正确的购买张数', trigger: 'blur' }
        ],
        optionRefundDay: [
          { pattern: /^[0-9]\d{0,2}$/, message: '请输入正确的时间限制天', trigger: 'blur' }
        ],
        travelDay: [
          { pattern: /^[0-9]\d{0,2}$/, message: '请输入正确的行程天', trigger: 'blur' }
        ],
        travelNight: [
          { pattern: /^[0-9]\d{0,2}$/, message: '请输入正确的行程晚', trigger: 'blur' }
        ],
        optionRefundHours: [
          { pattern: /^([0-9]|(1[0-9])|(2[0-3]))$/, message: '请输入正确的时间限制点', trigger: 'blur' }
        ],
        optionRefundMinute: [
          { pattern: /^[1-5]?\d([\/-][1-5]?\d)?$/, message: '请输入正确的时间限制分', trigger: 'blur' }
        ]

      }
    }
  },
  mounted() {
    this.getProOptionInfo()
  },
  methods: {
    getIsPlayName(data) {
      this.getLogUtils().logWithTag('getIsPlayName', data)
      this.ruleForm.optionIsPlayName = data
    },
    getSelectTourist(data) {
      this.getLogUtils().logWithTag('getSelectTourist', data)
      this.ruleForm.optionTouristinformation = data
    },
    changeLinkMan(data) {
      this.getLogUtils().logWithTag('changeLinkMan', data)
      this.ruleForm.optionContractInfo = data.str
      this.ruleForm.optionMustContractInfo = data.requiredStr
    },
    checkForm() {
      if (this.ruleForm.optionIsPlayName != 0) {
        if (this.ruleForm.optionTouristinformation && this.ruleForm.optionTouristinformation.length < 1) {
          this.$message.error('请选择游客信息证件')
          return false
        }
      }
      return true
    },
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          if (this.checkForm()) {
            this.submitData()
          }
        } else {
          this.getLogUtils().logWithTag('错误', 'error submit!!')
          return false
        }
      })
    },
    // 保存接口
    submitData() {
      this.submitLoading = true
      this.submitFormData = JSON.parse(JSON.stringify(this.ruleForm))
      this.getLogUtils().logWithTag('submitData', this.submitFormData)
      this.submitFormData.optionMaxTotal = this.submitFormData.optionMaxTotal ? this.submitFormData.optionMaxTotal : 99
      this.submitFormData.optionTouristinformation = this.submitFormData.optionTouristinformation.join(',')
      if (this.submitFormData.optionBuyInAdvanceSet == 0) {
        this.submitFormData.optionAdvanceDay = ''
        this.submitFormData.optionAdvanceHours = ''
        this.submitFormData.optionAdvanceMinute = ''
      }
      if (this.submitFormData.optionBuyInAdvanceSet == 1) {
        this.submitFormData.optionAdvanceDay = ''
        this.submitFormData.optionAdvanceHours = this.submitFormData.optionAdvanceHours1
        this.submitFormData.optionAdvanceMinute = this.submitFormData.optionAdvanceMinute1
      }
      delete this.submitFormData.hotelOptionInfo
      delete this.submitFormData.ticketInfo
      delete this.submitFormData.optionAdvanceHours1
      delete this.submitFormData.optionAdvanceMinute1
      this.getHttpServices().getProService().post('ticket/saveTicketType', this.submitFormData).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.$message.success('票型信息保存成功')
        this.ruleForm.ratePlanId = res
        this.$router.push({
          name: 'OptionList',
          query: {
            proId: this.proId,
            catalogId: this.catalogId,
            proSource: this.proSource
          }
        })
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    // 获取信息
    getProOptionInfo() {
      if (this.optionId != 0) {
        this.getHttpServices().getProService().get('ticket/getTicketTypeByOptionId/' + this.optionId).then(res => {
          this.getLogUtils().logWithTag('getProOptionInfo', res)
          this.ruleForm = res
          this.ruleForm.optionTouristinformation = res.optionTouristinformation ? res.optionTouristinformation.split(',') : []
          if (res.optionBuyInAdvanceSet == 0) {
            this.ruleForm.optionAdvanceDay = ''
            this.ruleForm.optionAdvanceHours = ''
            this.ruleForm.optionAdvanceMinute = ''
          } else if (res.optionBuyInAdvanceSet == 1) {
            this.ruleForm.optionAdvanceDay = ''
            this.ruleForm.optionAdvanceHours1 = res.optionAdvanceHours
            this.ruleForm.optionAdvanceMinute1 = res.optionAdvanceMinute
            this.ruleForm.optionAdvanceHours = ''
            this.ruleForm.optionAdvanceMinute = ''
          }
          this.ruleForm = { ...this.ruleForm }
          this.$refs.linkMan.getLinkInfo(this.ruleForm.optionContractInfo, this.ruleForm.optionMustContractInfo)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
      } else {
        this.$refs.linkMan.getLinkInfo(this.ruleForm.optionContractInfo, this.ruleForm.optionMustContractInfo)
      }
    }
  }

}
</script>
<style lang="less" scoped>
.page-box {
  .page-main {
    margin: 10px;
    display: flex;

    .main-content {
      margin-left: 10px;
      width: 400px;
      flex-grow: 1;

      .inline {
        display: inline-block;
      }

      .ml15 {
        margin-left: 15px;
      }

      .mr15 {
        margin-right: 5px;
      }

      .mb0 {
        margin-bottom: 0;
      }

      .lh40 {
        line-height: 40px;
      }
    }
  }
}

.pt10 {
  padding-top: 10px;
}

.card-title {
  padding-left: 10px;
  border-left: 1px solid #FAAD14;
  line-height: 32px;
  margin-right: 5px;
}

.card-txt {
  font-size: 12px;
}

/* you can make up upload button and sample style by using stylesheets */
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
</style>
